import type { Alert } from '@/api/alert/types/alert';

let pushNavigationReady = false;
let pendingPushAlert: Alert | null = null;

export const isPushNavigationReady = () => pushNavigationReady;

export const queueOrNavigatePushAlert = (alert: Alert, navigate: (alert: Alert) => void) => {
  if (pushNavigationReady) {
    navigate(alert);
    return;
  }
  pendingPushAlert = alert;
};

export const markPushNavigationReady = (navigate: (alert: Alert) => void) => {
  pushNavigationReady = true;
  if (!pendingPushAlert) return;
  const alert = pendingPushAlert;
  pendingPushAlert = null;
  navigate(alert);
};

export const resetPendingPushNavigation = () => {
  pushNavigationReady = false;
  pendingPushAlert = null;
};
